// extracted by mini-css-extract-plugin
module.exports = {"root":"ActiveShutdowns_root__1GnTL","collapse":"ActiveShutdowns_collapse__3ZA-_","panel":"ActiveShutdowns_panel__7sfSG","title":"ActiveShutdowns_title__1EnVa"};